<template>
  <div :class="{ 'offset-top': isSecond }">
    <section class="my-5 marketplace" id="section-2">
      <div class="container-fluid">
        <div class="row">
          <div class="col-10 mx-auto col-md-3 col-lg-2 mb-5">
            <Sidebar />
          </div>

          <div class="col-sm-12 col-md-9 col-lg-10 text-center mb-3">
            <div class="row text-center justify-content-around mb-4">
              <div class="col-12">
                <h5 class="text-center mb-4">
                  <span style="font-weight: 700;">Market Place:</span>
                  {{ title }}
                </h5>
              </div>

              <div class="col-sm-6 col-md-4 col-lg-3 my-3">
                <router-link to="/marketplace/details">
                  <img
                    class="img-fluid mb-3 border border-dark"
                    src="assets/images/soybean.jpg"
                    alt="Product Image"
                  />
                  <h6 class="font-weight-bold">Soyabeans</h6>
                  <p class="mb-0">120,000 Tonnes available</p>
                  <p class="mb-0 font-weight-bold">&#35;140,000 / Tonne</p>
                </router-link>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-3 my-3">
                <router-link to="/marketplace/details">
                  <img
                    class="img-fluid mb-3 border border-dark"
                    src="assets/images/maize.jpg"
                    alt
                  />
                  <h6 class="font-weight-bold">Maize</h6>
                  <p class="mb-0">120,000 Tonnes available</p>
                  <p class="mb-0">&#35;140,000 / Tonne</p>
                </router-link>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-3 my-3">
                <router-link to="/marketplace/details">
                  <img
                    class="img-fluid mb-3 border border-dark"
                    src="assets/images/soghurm.jpg"
                    alt
                  />
                  <h6 class="font-weight-bold">Sorghum</h6>
                  <p class="mb-0">120,000 Tonnes available</p>
                  <p class="mb-0">&#35;140,000 / Tonne</p>
                </router-link>
              </div>
              <div class="w-100"></div>
              <div class="col-sm-6 col-md-4 col-lg-3 my-3">
                <router-link to="/marketplace/details">
                  <img
                    class="img-fluid mb-3 border border-dark"
                    src="assets/images/sesame.jpg"
                    alt
                  />
                  <h6 class="font-weight-bold">Sesame</h6>
                  <p class="mb-0">120,000 Tonnes available</p>
                  <p class="mb-0">&#35;140,000 / Tonne</p>
                </router-link>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-3 my-3">
                <router-link to="/marketplace/details">
                  <img
                    class="img-fluid mb-3 border border-dark"
                    src="assets/images/cocoa.jpg"
                    alt
                  />
                  <h6 class="font-weight-bold">Cocoa</h6>
                  <p class="mb-0">120,000 Tonnes available</p>
                  <p class="mb-0">&#35;140,000 / Tonne</p>
                </router-link>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-3 my-3">
                <router-link to="/marketplace/details">
                  <img
                    class="img-fluid mb-3 border border-dark"
                    src="assets/images/Ginger.jpg"
                    alt
                  />
                  <h6 class="font-weight-bold">Ginger</h6>
                  <p class="mb-0">120,000 Tonnes available</p>
                  <p class="mb-0">&#35;140,000 / Tonne</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Sidebar from "@/components/MarketSidebar.vue";
export default {
  components: { Sidebar },
  props: {
    isSecond: {
      type: Boolean,
      default: false,
      required: false,
      description: "Marketplace top offset spacing"
    },

    title: {
      type: String,
      required: true,
      description: "Marketplace Title"
    }
  }
};
</script>
<style>
.offset-top {
  margin-top: -50px !important;
}
</style>
